export interface KissNavigationSidebar {
  enable?: boolean;
  position?: 'left' | 'right';
  expand?: boolean;
}
